/**
 * Where the API lives. Compiled into the bundle at build time, which is why the web
 * application is built once per environment rather than once for both.
 *
 * VITE_API_BASE_URL is the API's *origin* - https://quotehero-staging-api.azurewebsites.net -
 * and the version prefix is appended here. The prefix belongs with the code that knows the
 * routes, not in a pipeline variable called "api base url", which reads as an origin to
 * everyone who has ever filled one in. It was filled in as an origin, the bundle asked for
 * /meta/auth-config, and nobody could sign in to staging.
 *
 * Unset, this resolves to a relative /api/v1, which the Vite dev server proxies.
 *
 * A value that already carries the prefix, or a trailing slash, is accepted rather than
 * turned into /api/v1/api/v1: the mistake costs a pipeline run and a broken environment to
 * find, which is a steep price for a string.
 *
 * Not a secret: every browser that loads the application can read it.
 */
const PREFIX = '/api/v1'

const origin = (import.meta.env.VITE_API_BASE_URL ?? '')
  .trim()
  .replace(/\/+$/, '')
  .replace(/\/api\/v1$/, '')

export const BASE = origin + PREFIX
